// extracted by mini-css-extract-plugin
export default {"root":"IconPetPaw_root__hC97f"};